import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import AllProjects from "./pages/AllProjects";
import AllSections from "./pages/AllSections";
import "./App.css";

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Routes>
        <Route path="/" element={<AllSections />} />
        <Route path="/projects" element={<AllProjects />} />
      </Routes>
    </>
  );
}

export default App;
